<template>
  <div>
  <section>
    <div class="left">
      <detail-entity-info
          :entity="entity"
          :omit-default="['id_remote']"
      >
      </detail-entity-info>
    </div>
  <div class="right">
    <div class="field_left">
      <text-input id="thematicGroupname"
                  :required="true"
                  v-model="entity.name"
                  :disabled="disabled"
                  ref="nameref"
                  v-bind:help-text="!isCustom && entity.baseData && entity.baseData.hasOwnProperty('name') ? $gettext('výchozí')+': '+entity.baseData.name: undefined"
      >
        <translate class="translate">Název</translate>
        <a
            v-if="!disabled
            && !isCustom
            && entity.baseData
            && entity.baseData.hasOwnProperty('name')
            && entity.baseData.name !== entity.name"
            class="reset_btn"
            :title="$gettext('Nastavit výchozí hodnotu')"
            @click.stop.prevent="entity.name = entity.baseData.name"
        >Resetovat</a>
      </text-input>
      <checkbox-input
          id="thematicGroupDeviceVisibility"
          v-model="entity.device_visibility"
          ref="devicevisibilityref"
          :disabled="disabled"
          v-bind:help-text="entity.baseData && entity.baseData.hasOwnProperty('device_visibility') ? $gettext('výchozí')+': '+getDeviceVisibilityBaseText: undefined"
      >
        <translate class="translate">Viditelné na zařízeních</translate>
      </checkbox-input>
    </div>
  </div>
  </section>
    <section>
      <div class="left">
        <h2 v-translate>Překlady názvu</h2>
        <div class="left">
          <a
              v-if="!disabled && !isCustom && !isTranslationsSame"
              :title="$gettext('Nastavit výchozí hodnotu')"
              @click.stop.prevent="entity.translations = { ...entity.baseData.translations}"
          v-translate>Nastavit výchozí hodnoty</a>
        </div>
      </div>
      <div class="right">
        <div :class="[index % 2 ? 'field_right' : 'field_left']" v-for="(language, key, index) in languages">
          <text-input :id="'tranlation_'+key"
                      :required="true"
                      :disabled="disabled"
                      v-model="entity.translations[key]"
                      :ref="'tranlation_'+key+'_ref'"
                      v-bind:help-text="!isCustom  && entity.baseData && entity.baseData.hasOwnProperty('translations') ? $gettext('výchozí')+': '+entity.baseData.translations[key]: undefined"
          >
            {{language}}
          </text-input>
        </div>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Kanály</h2>
        <div class="left">
          <a
              v-if="!disabled && !isCustom && !isChannelsSame"
              :title="$gettext('Nastavit výchozí hodnotu')"
              @click.stop.prevent="entity.id_channels = [ ...entity.baseData.id_channels]"
              v-translate>Resetovat pořadí kanálů</a>
        </div>
      </div>
      <div class="right">
        <SortableCheckboxList
            v-if="channels.length > 0"
            :items="channels"
            :is-channel-list="true"
            v-model="entity.id_channels"
            :disabled="disabled"
            :allow-selecting="entity.custom_group"
            name="channels"
        >
        </SortableCheckboxList>
      </div>
    </section>
  </div>
</template>

<script>
import Message from "../../../mixins/message";
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import SortableCheckboxList from "../../../common/SortableCheckboxList.vue";
import {getCorrectBooleanValue} from "@/utils/helpers"

export default {
  name: "ThematicGroupBasicForm",
  components: {DetailEntityInfo, SortableCheckboxList},
  mixins: [Message],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  created(ChannelService) {
    this.channelService = ChannelService;
    this.reloadChannels();
  },
  data(){
    return {
      selectedLanguage: null,
      channels: [],
      languages: {
        'ces': this.$gettext('Čeština'),
        'eng': this.$gettext('Angličtina'),
        'deu': this.$gettext('Němčina'),
        'slk': this.$gettext('Slovenština'),
        'hun': this.$gettext('Maďarština')
      },
    }
  },
  computed: {
    disabled(){
      return !this.isEditable || !this.$_updateActionAllowed;
    },
    isCustom(){
      return this.entity.custom_group;
    },
    getDeviceVisibilityBaseText(){
      return this.entity.baseData.device_visibility ? this.$gettext('Ano') : this.$gettext('Ne');
    },
    isTranslationsSame(){
      if(!this.entity.baseData || !this.entity.baseData.hasOwnProperty('translations')){
        return true;
      }

      return Object.keys(this.entity.translations).every(key => this.entity.baseData.translations.hasOwnProperty(key)
          && this.entity.translations[key] === this.entity.baseData.translations[key]);
    },
    isChannelsSame(){
      if(!this.entity.baseData || !this.entity.baseData.hasOwnProperty('id_channels')){
        return true;
      }

      return this.entity.id_channels.every((value, index) => value === this.entity.baseData.id_channels[index]);
    }
  },
  methods:{
    reloadChannels() {
      this.setLoadingMessage();
      this.channelService.channelList({id_operator: this.entity.id_operator})
          .then((data) => {
            this.channels = data['channels'];
            this.emptyMessage(true);
          })
    }
  },
  watch: {
    'entity.id_operator': function (){
      this.reloadChannels();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/thematicGroups/forms/ThematicGroupBasicForm.vue